export const contentNoteTestIds = {
  noteContent: "note-content",
  date: "note-date",
  title: "note-title",
  error: "note-error",
  loading: "admin-note-loading",
};
